<template>
  <div class="border-right">
    <slo-upload-modal></slo-upload-modal>
    <div class="btn-container bg-cx3 p-2 d-flex justify-content-between">
      <button class="btn btn-sm btn-outline-light border-0" @click="newOrder">
        <i class="far fa-edit"></i> New
      </button>
      <button class="btn btn-sm btn-outline-light border-0" @click="openUploadModal">
        <i class="fa fa-upload"></i> Upload
      </button>
      <button class="btn btn-sm btn-outline-light border-0" @click="refresh">
        <i class="fa fa-sync-alt" :class="{'fa-spin': loading}"></i>
      </button>
    </div>
    <div class="list-group">
      <router-link :to="'/special-orders'" 
        exact
        class="list-group-item list-group-item-action d-flex flex-row justify-content-between border-0"
      > 
        <span>
          <i class="far fa-folder mr-2"></i>
          All
        </span>
      </router-link>
      <template v-for="status in statuses" >
        <router-link :to="'/special-orders/' + status.slug" 
          v-if="!status.hide"
          :key="status.id"
          class="list-group-item list-group-item-action d-flex flex-row justify-content-between border-0"
          :class="{ active: status.active }"
        > 
          <span>
            <i class="far fa-folder mr-2" :class="{'fa-folder-open': status.active}"></i>
            {{ status.name }}
          </span>
          <span v-if="status.ct" class="badge badge-light">{{ status.ct }}</span>
        </router-link>
      </template>
    </div>
  </div>
</template>

<script>
import $ from 'jquery'
import SloUploadModal from '@/components/special-orders/UploadModal.vue'

export default {
  name: 'status-menu',

  props: ['statuses'],

  data() {
    return {
      loading: false
    }
  },

  components: {
    SloUploadModal,
  },

  methods: {
    refresh() {
      this.$emit('refresh')
    },

    newOrder() {
      alert('Not yet, but soon.')
    },
    
    openUploadModal() {
      $('#sloUploadModal').modal('show')
    }
  }
}
</script>

<style scoped>
  .badge {
    padding: 5px;
  }
  .list-group {
    height: calc(100vh - 104px);
    background: none;
    opacity: .8;
  }

  .list-group-item {
    color: #efefef;
    background: transparent;
    padding: 0.5rem 1rem;
    border:0;
  }

  .list-group-item-action:hover {
    background-color: rgb(53, 73, 104);
    color: #fff;
  }

  .list-group-item.active {
    background: rgb(53, 73, 104);
    border: 0;
  }
  .btn-container {
    margin-top: 0px;
    opacity: .8;
    border-bottom:1px solid rgb(53, 73, 104);
  }
</style>
